import { Fragment } from 'react';
import { useFirestoreAllID } from '../../firebase/useFirestore'

const CustomEventFieldMeta = ({fieldId}) => {

    const eventField = useFirestoreAllID('CustomEventFields', fieldId || "");

  return (
    <>
        {eventField && eventField.map(field => (
             <Fragment key={field.ID}>
                {field.Title}
            </Fragment>
        ))}
    </>
  )
}

export default CustomEventFieldMeta